export enum DocumentType {
    MARKDOWN = "MARKDOWN",
    UNSPECIFIED = "UNSPECIFIED",
    NOTE = "NOTE",
    WEBSITE = "WEBSITE",
    PDF = "PDF",
    GENERIC_FILE = "GENERIC_FILE",
    ATLAS_BOARD = "ATLAS_BOARD"
}
